type PedometerGiftiShopQueryKeys = {
  GIFTI_SHOP_PAYMENTS: { date: string };
  GIFTI_SHOP_ITEM_LIST: undefined;
  GIFTI_SHOP_ITEM: { id: number };
};

export const getQueryKey = <T extends keyof PedometerGiftiShopQueryKeys>(
  ...[key, params]: undefined extends PedometerGiftiShopQueryKeys[T]
    ? [T]
    : [T, PedometerGiftiShopQueryKeys[T] | 'KEY_ONLY']
) => {
  if (params === 'KEY_ONLY') return [key];
  return params ? [key, params] : [key];
};
